import { createApiRef } from '@backstage/frontend-plugin-api';
import {
  Project,
  ProjectMode,
  BulkResult,
  LockActionRequest,
  ModeActionRequest,
  OperationFilters,
  OperationPage,
} from './types';

export const kargoApiRef = createApiRef<KargoApi>().with({
  id: 'plugin.kargo.service',
});

export interface KargoApi {
  listProjects(): Promise<Project[]>;
  getProject(name: string): Promise<Project>;
  lockProject(name: string, req?: LockActionRequest): Promise<void>;
  unlockProject(name: string, req?: LockActionRequest): Promise<void>;
  setMode(
    name: string,
    mode: ProjectMode,
    req?: ModeActionRequest,
  ): Promise<void>;
  lockAll(req?: LockActionRequest): Promise<BulkResult>;
  unlockAll(req?: LockActionRequest): Promise<BulkResult>;
  listOperations(filters?: OperationFilters): Promise<OperationPage>;
}
